module.exports = __webpack_public_path__ + "img/top2.d67ae668.png";